import React from 'react'

export const Wrapper = ({ children, ...props }) => {
  return (
    <section className="balto-wrapper" {...props}>
      {children}
    </section>
  )
}
